import { Dispatch, FC, ReactNode, SetStateAction } from 'react'
import { useIntl } from 'react-intl'
import { generatePath, Link } from 'react-router'

import { BarsOutlined } from '@ant-design/icons'
import { Button, Card, Flex, Image, Typography } from 'antd'

import { Country } from '../../components/icon/Country'
import { Title } from '../../components/text/Title'
import routes from '../../routes'

const TrackCard: FC<
  Partial<TrackCardFragment> & {
    selected?: string[]
    onSelect?: Dispatch<SetStateAction<string[]>>
    action?: ReactNode
    results?: ({ year?: number | null } | null)[]
  }
> = ({ slug = '', results = [], selected = [], onSelect = () => undefined, action, ...props }) => {
  const { formatMessage } = useIntl()
  const message =
    results.length === 1
      ? 'етап'
      : (results.length > 1 && results.length < 5) || results.length.toString().match(/[2-9][2-4]/)
        ? 'етапи'
        : results.length.toString().endsWith('1')
          ? 'етап'
          : 'етапів'
  return (
    <Card
      cover={
        <Image
          style={{ objectFit: 'contain', padding: '54px 16px 0px' }}
          height={240}
          preview={false}
          src={`${props.layout?.url}`}
        />
      }
    >
      <Flex style={{ position: 'relative', top: -240, width: 40 }} justify={'space-between'}>
        {action ?? (
          <Button
            title={formatMessage({ id: 'riders.add-to-compare' })}
            icon={<BarsOutlined />}
            shape={'circle'}
            type={selected.find((i) => slug === i) ? 'primary' : 'default'}
            onClick={() => {
              if (selected.find((i) => slug === i) === undefined) {
                onSelect((prevState) => prevState.concat(slug))
              } else {
                onSelect((prevState) => prevState.filter((e) => e !== slug))
              }
            }}
          />
        )}
      </Flex>
      <Flex vertical gap={8} style={{ marginTop: -16 }}>
        <Flex gap={12} justify={'space-between'} align={'center'}>
          <Title ellipsis style={{ marginBottom: 0 }} level={4}>
            <Link to={generatePath(routes.track, { slug })}>{props.name}</Link>
          </Title>
          <Country country={props.country} />
        </Flex>
        <Flex align={'center'} justify={'space-between'}>
          {results?.length > 0 ? (
            <>
              <Typography.Text>
                {[results?.[results?.length - 1]?.year, results?.[0]?.year].join(' - ')}
              </Typography.Text>
              <Typography.Text>{[results?.length, message].join(' ')}</Typography.Text>
            </>
          ) : (
            <Typography.Text>&nbsp;</Typography.Text>
          )}
        </Flex>
      </Flex>
    </Card>
  )
}

export { TrackCard }
